// import {extent as d3_extent} from 'd3-array'
import { select as d3_select } from 'd3-selection'
import IconIncreaseTextSize from '../styles/icons/icon-increase-text-size.svg'
import IconDarkMode from '../styles/icons/icon-dark-mode.svg'
import IconContrast from '../styles/icons/icon-contrast.svg'
import IconGuideLines from '../styles/icons/icon-guide-lines.svg'
import AccessibilityIcon from '../styles/icons/icon-accessibility.svg'
import { ACCESSIBILITY_OPTIONS_KEYS } from '../utils/accessibilityUtils'
import { isDarkMode } from '../utils/configUtils'

function GuideLinesBehavior($root, chart, config = {}) {
  //Draw container
  //chart._parent.accessibilityOptions
  const rootContentRect = $root.getBoundingClientRect()
  const drawGuideLines = () => {
    let guideLinesGroup = d3_select($root)
      .selectAll('.guide-lines')
      .data(
        chart._parent.accessibilityOptions?.[ACCESSIBILITY_OPTIONS_KEYS.guideLines] ? [null] : []
      )
    const guideLinesGroupEnter = guideLinesGroup
      .enter()
      .append('g')
      .attr('class', 'guide-lines')
      .style('pointer-events', 'none')
    guideLinesGroup.exit().remove()
    guideLinesGroup = guideLinesGroup.merge(guideLinesGroupEnter)

    let guideLines = guideLinesGroup.selectAll('.guide-line').data(['x', 'y'])
    const guideLinesEnter = guideLines
      .enter()
      .append('line')
      .attr('class', 'guide-line')
      .attr('stroke-width', '1')
      .attr('stroke-dasharray', '1')
      .attr('stroke', '#727272')
    guideLines = guideLines.merge(guideLinesEnter)
    guideLines.exit().remove()

    if (chart._parent.accessibilityOptions?.[ACCESSIBILITY_OPTIONS_KEYS.guideLines]) {
      d3_select($root).on('mousemove', event => {
        const mouseX = event.offsetX
        const mouseY = event.offsetY

        const MAX_WIDTH = rootContentRect.width
        const MAX_HEIGHT = rootContentRect.height

        guideLines
          .attr('x1', d => (d === 'x' ? 0 : mouseX))
          .attr('x2', d => (d === 'x' ? MAX_WIDTH : mouseX))
          .attr('y1', d => (d === 'y' ? 0 : mouseY))
          .attr('y2', d => (d === 'y' ? MAX_HEIGHT : mouseY))
      })
      d3_select($root).on('mouseleave', event => {
        guideLines.transition().duration(200).style('opacity', 0)
      })
      d3_select($root).on('mouseenter', event => {
        guideLines.transition().duration(200).style('opacity', 1)
      })
    } else {
      d3_select($root).on('mousemove', null)
      d3_select($root).on('mouseleave', null)
      d3_select($root).on('mouseenter', null)
    }
  }

  drawGuideLines()
}

GuideLinesBehavior.defaultConfig = {
  index: 205,
}
GuideLinesBehavior.configName = 'GuideLinesBehavior'

export default GuideLinesBehavior
